import notify from 'devextreme/ui/notify';
import { confirm, alert } from 'devextreme/ui/dialog';

export class Message {

    static position = 'top center';
    static displayTime = 5000;

    static toast(message: string, type: string = 'success') {

        const object = {
            message: message,
            type: type,
            displayTime: Message.displayTime,
            position: Message.position
        };

        notify(object);
    }

    static toastHTML(message: string, type: string) {
        const template = `<div data-options="dxTemplate: { name:'myContent' }">` + message + `</div>`;

        const object = {
            contentTemplate: template,
            type: type,
            displayTime: Message.displayTime,
            position: Message.position
        };

        notify(object);
    }
    /*
    static confirm(message, title = 'Pregunta', cb?) {
        const result = confirm(message, title);
        result.done((dialogResult) => {
            if (cb !== null) {
                // Llamamos a la función de CallBack pasándole el booleano de la respuesta
                cb(dialogResult);
            }
        });
    }

    static alert(message, title = 'Información', cb = null) {
        const result = alert(message, title);
        result.done(() => {
            if (cb !== null) {
                cb();
            }
        });
    }
    */
}



// WEBPACK FOOTER //
// ./src/app/utils/utils/message.ts